module.exports = __webpack_public_path__ + "static/media/2.970885c1.jpg";